import { GameInfo } from '../../domain/signals/game-info';

export class SignalrMockData {

    static WINNING_PLAN: GameInfo = {
        State: GameInfo.States.WINNING_PLAN,
        WinPlan: {
            WinningTable: [
                {},
                {
                    1: 3
                },
                {
                    1: 1,
                    2: 8
                },
                {
                    2: 3,
                    3: 30
                },
                {},
                {},
                {},
                {},
                {
                    4: 4,
                    5: 16,
                    6: 60,
                    7: 200
                }
            ]
        }
    } as GameInfo;

    static BET_START: GameInfo = {
        State: GameInfo.States.BET_START,
        BetAcceptanceTime: 151,
        Game: {
            BingoGameID: 166668,
            Calculated: false,
            GameDate: "2017-07-24T13:14:53.5024661+02:00"
        }
    } as GameInfo;

    static DRAWING: GameInfo = {
        State: GameInfo.States.DRAWING,
        BetAcceptanceTime: 0,
        Game: {
            BingoGameID: 166668,
            Calculated: false,
            GameDate: "2017-07-24T13:14:53.5024661+02:00",
            Drawn: '2, 7, 9, 10, 15, 18, 22, 25, 26, 33, 34, 35, 39, 46, 49,52, 53, 57, 59, 65',
            Extra: '11, 12'
        }
    } as GameInfo;
}


// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/signalr/signalr-mock-data.ts